import Header from "@/components/Header";
import Footer from "@/components/Footer";
import SEOHead from "@/components/SEOHead";

export default function Layout({ children }) {
  return (
    <div className="min-h-screen flex flex-col bg-cream">
      <SEOHead />
      <Header />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
}
